module.exports = __webpack_public_path__ + "static/img/screenshots-windows.fbfd77a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/images/screenshots-windows.png
// module id = X2R+
// module chunks = 26